export default "__VITE_ASSET__pzEFZo87__"